import classnames from 'classnames';

export const themes = {
  default: ({ onClick }) => ({
    thRoot: 'bg-current inline-flex items-stretch rounded-tiny text-base',
    thBody: classnames('flex items-center font-bold leading-one m-1 text-current', {
      'reset-button': onClick,
    }),
    thBadgeStyle: { width: '1.5em', height: '1.5em' },
    thBadge:
      'bg-white flex items-center justify-center leading-one m-1 overflow-hidden rounded-full text-center',
    thBadgeLabel: 'text-sm',
    thIconSize: '1em',
    thIconLeft: 'm-1 text-white',
    thIconRight: 'm-1 text-white',
    thLabel: 'm-1 text-white',
    thClose: 'p-2 reset-button text-white',
    thCloseSize: '0.625em',
  }),
  outlined: ({ onClick }) => ({
    thRoot: 'border-2 border-current inline-flex items-stretch text-sm',
    thBody: classnames('flex items-center font-bold leading-one px-2 py-1 text-current uppercase', {
      'reset-button': onClick,
    }),
    thBadgeStyle: { width: '2em', height: '2em' },
    thBadge:
      'bg-white border-1 border-current flex items-center justify-center leading-one m-1 overflow-hidden rounded-full text-center',
    thBadgeLabel: '',
    thIconSize: '1em',
    thIconLeft: 'm-1',
    thIconRight: 'm-1',
    thLabel: 'm-1',
    thClose: 'm-2 reset-button text-current',
    thCloseSize: '0.625em',
  }),
  outlinedThin: ({ onClick, active }) => ({
    thRoot: classnames('border border-current items-stretch rounded-tiny text-sm', {
      'bg-current': active,
    }),
    thBody: classnames('flex items-center leading-one px-2 py-1 text-base text-current', {
      'reset-button': onClick,
    }),
    thBadgeStyle: { width: '2em', height: '2em' },
    thBadge:
      'bg-white border-1 border-current flex items-center justify-center leading-one m-1 overflow-hidden rounded-full text-center',
    thBadgeLabel: '',
    thIconSize: '1em',
    thIconLeft: classnames('m-1', { 'text-white': active }),
    thIconRight: classnames('m-1', { 'text-white': active }),
    thLabel: classnames('m-1 whitespace-no-wrap', { 'text-white': active }),
    thClose: classnames('m-2 reset-button text-current', { 'text-white': active }),
    thCloseSize: '0.625em',
  }),
};
